import {
    Component,
    Input,
    EventEmitter,
    Output,
    ElementRef,
    Renderer2,
    ViewChild,
    ViewEncapsulation
} from '@angular/core'

@Component({
    selector: 'card-hero',
    templateUrl: './renderCardHero.component.html',
    styleUrls: ['./renderCardHero.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class RenderCardHero {

    @Input() data: any;

    @Output() clickEvent: EventEmitter<any> = new EventEmitter();

    @ViewChild('interactionsList', {static: true}) interactionsList;

    constructor(
        private _El: ElementRef,
        private _R: Renderer2
    ) { }

    ngOnInit() {
        // start entry animation
        this.animationStart();
    }

    /**
     * Animacao de entrada dos botoes
     */
    animationStart() {
        setTimeout(() => {
            this._R.addClass(this.interactionsList.nativeElement, 'on-entry');
        }, 2500);
    }

    /**
     * Recebe um click e emite um evento com esse valor para o elemento pai (message.component)
     *
     * @param value valor da mensagem clicada
     */
    messageClicked(value) {
        this.clickEvent.emit({
            event: event,
            value: value
        });
        this._R.addClass(event.target, 'active');
        this.disableButtons();
    }

    /**
     * Desabilita todos os botons, exeto o clicado
     */
    disableButtons() {
        let buttons = Array.from(this._El.nativeElement.querySelectorAll('.interaction-button:not(.active)'));

        buttons.map((el, idx) => {
            this._R.addClass(el, 'disabled');
        });
    }

    /**
     * Retorna o id do ícone com base na url
     *
     * @param {string} imageUrl
     */
    getIconId(imageUrl: string) {
        return imageUrl.split('#').pop().replace('.svg', '');
    }
}
